import { component } from 'picoapp';
import Swiper, {
  SwiperOptions, Autoplay, EffectFade, Pagination,
} from 'swiper';

export default component(async (node) => {
  const autoplayDelay:number = parseInt(node.dataset.delay, 10);

  const swiperParams:SwiperOptions = {
    modules: [Autoplay, EffectFade, Pagination],
    autoplay: {
      delay: autoplayDelay,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    init: false,
  };

  const swiper = new Swiper(node, swiperParams);

  swiper.init();
});
